import React, { useState, useMemo, useCallback, useRef, useEffect } from "react";
import styles from "./index.module.less";
import Icon, { Icons } from "../../../Icon";
import { Popover, Modal, Form, message } from "antd";
import { createTag, deleteTag, updateTag } from "../../../api/tags";
import { connect } from "dva";
import { FolderTypeNames } from "../../../config/permissions.config";
import { JoyspaceState } from "@/models/joyspace";
import AutoCloseInput from "./AutoCloseInput";
import { useTranslation } from "../../../context";
import { useNavigator } from "@/utils/NetworkCheck";

const { confirm } = Modal;

function LeafTreeNodeTitle(props: any) {
  const onLine = useNavigator.onLine;
  const {
    ownItem,
    layer,
    width,
    item,
    getTags,
    folderInfoMap,
    setFolderInfoMap,
    treeDataInfo,
    updateTreeDataInfo,
    onSelect,
    changeRightUrl,
    selectedKeys
  } = props;
  const [name, setName] = useState(ownItem.name || "");
  const [visible, setVisible] = useState(false);
  const [validateStatus, setValidateStatus] = useState<"success" | "error">("success");
  const [isShowEdit, setIsShowEdit] = useState(false);
  const [toolsVisible, setToolsVisible] = useState(false);

  const lang = useTranslation();

  const content = useMemo(() => {
    return (
      <>
        <div
          className={`${styles["leaf_treenode_btn_wrap"]} ${styles["leaf_treenode_btn_wrap_rename"]}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            // setName(ownItem.name);
            setVisible(false);
            setIsShowEdit(true);
          }}
        >
          <Icon className={styles["leaf_treenode_btns_icon"]} type="iconapp_ic_edit_bjq" />
          {lang("common.rename")}
        </div>
        <div
          className={`${styles["leaf_treenode_btn_wrap"]} ${styles["leaf_treenode_btn_wrap_delete"]}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setVisible(false);
            confirm({
              title: lang("tags.delete"),
              content: lang("tags.delete-tag-prompt"),
              okText: lang("confirm"),
              cancelText: lang("cancel"),
              onOk() {
                deleteTag({ id: ownItem.id }).then(() => {
                  getTags(FolderTypeNames.TAGS).then((res: any) => {
                    const tagList = res?.items;
                    if (tagList?.length === 0) {
                      onSelect("myspace", {
                        node: {
                          key: "myspace",
                          className: "first-level-node"
                        }
                      });
                      changeRightUrl({ to: "/joyspace/myspace" });
                    } else if (selectedKeys[0] === ownItem?.id?.toString()) {
                      onSelect([tagList[0].id.toString()], {
                        node: {
                          key: tagList[0].id,
                          "data-type": FolderTypeNames.TAGS
                        }
                      });
                    }
                  });
                });
              }
            });
          }}
        >
          <Icon className={styles["leaf_treenode_btns_icon"]} type="iconapp_ic_delete" />
          {lang("tags.delete")}
        </div>
      </>
    );
  }, [selectedKeys]);

  const onCreateTag = useCallback(
    async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!name.trim()) {
        setValidateStatus("error");
        return;
      } else {
        setValidateStatus("success");
      }
      if (ownItem.isNew) {
        createTag({ name: name.trim() })
          .then((res: any) => {
            if (res.code !== "200") {
              message.error(res.status);
            }
            ownItem.isNew = false;
            setIsShowEdit(false);
            getTags(FolderTypeNames.TAGS);
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (isShowEdit) {
        updateTag({ id: ownItem.id, name: name.trim() }).then((res: any) => {
          if (res.code !== "200") {
            message.error(res.status);
          }
          setName(name.trim());
          setIsShowEdit(false);
          getTags(FolderTypeNames.TAGS);
        });
      }
    },
    [name, isShowEdit]
  );
  return (
    <div
      className={`nav-tree-item-title ${styles["leaf_treenode_container"]}`}
      id={item.id}
      onMouseEnter={() => {
        setToolsVisible(true);
      }}
      onMouseLeave={() => {
        setToolsVisible(false);
      }}
    >
      <div className="nav-item-content tag-left">
        <Icon type="iconbiaoqian" className="icon" />
        <div className="nav-item-name" style={{ width: width - layer * 24 - 24 - 24 }}>
          {isShowEdit || ownItem.isNew ? (
            <Form>
              <Form.Item validateStatus={validateStatus}>
                <AutoCloseInput
                  name={name}
                  onCreateTag={onCreateTag}
                  setName={setName}
                  ownItem={ownItem}
                  setIsShowEdit={setIsShowEdit}
                  outSideClick={() => {
                    if (ownItem.isNew) {
                      const index = treeDataInfo.findIndex(
                        (data: any) => data.type === FolderTypeNames.TAGS
                      );
                      Reflect.deleteProperty(folderInfoMap, ownItem.id);
                      setFolderInfoMap({ ...folderInfoMap });
                      const children = treeDataInfo[index].children.filter(
                        (item: any) => item.id !== ownItem.id
                      );
                      treeDataInfo[index].children = children;
                      updateTreeDataInfo([...treeDataInfo]);
                    } else if (isShowEdit) {
                      setIsShowEdit(false);
                    }
                  }}
                />
              </Form.Item>
            </Form>
          ) : (
            <span className={styles["item"]}>
              <span className={styles["item_title"]}>
                {ownItem.name}({ownItem.count >= 100 ? "99+" : 0 + ownItem.count})
              </span>
              {onLine && toolsVisible && (
                <Popover
                  content={content}
                  // trigger="click"
                  visible={visible}
                  onVisibleChange={(visible) => setVisible(visible)}
                  placement="bottom"
                >
                  <Icon
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setVisible(!visible);
                    }}
                    type="iconlog_more"
                  />
                </Popover>
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    treeDataInfo: joyspace.treeDataInfo,
    expandedKeys: joyspace.expandedKeys,
    selectedKeys: joyspace.selectedKeys,
    folderInfoMap: joyspace.folderInfoMap
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setExpandedKeys(data: any) {
      dispatch({ type: "joyspace/setExpandedKeys", payload: data });
    },
    setFolderInfoMap(data: any) {
      return dispatch({ type: "joyspace/setFolderInfoMap", payload: { ...data } });
    },
    updateTreeDataInfo(data: any) {
      return dispatch({ type: "joyspace/updateTreeDataInfo", payload: data });
    },
    getTags(data: any) {
      return dispatch({ type: "joyspace/getTags", payload: { ...data } });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LeafTreeNodeTitle);
